import React from 'react';
import styled, { keyframes } from 'styled-components';
import { selectLoader } from '../selectors';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Colors } from 'planoplan-ui-kit/core/colors';

const mapStateToProps = (state) => ({
  status: selectLoader(state).status,
  progress: selectLoader(state).progress,
});

const enchance = compose(connect(mapStateToProps));

const LoaderView = ({ status }) => {
  if (status !== 'fetching') return null;
  return (
    <Container>
      <Progress />
    </Container>
  );
};

export const Loader = enchance(LoaderView);

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: ${Colors.light_gray};
  z-index: 1000;
`;
const fill = keyframes`
  100% {
    width: 100%
  } 
`;
const Progress = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  width: 0%;
  background-color: ${Colors.planoplan_blue};
  animation-name: ${fill};
  animation-duration: 1s;
  animation-fill-mode: forwards;
`;
